export interface ProjectFile {
  id: string;
  projectId: string;
  name: string;
  type: string;
  format: string;
  size: string;
  uploadedBy: string;
  uploadedAt: Date;
  version: number;
  url: string;
  comments?: FileComment[];
}

export interface FileComment {
  id: string;
  fileId: string;
  userId: string;
  userName: string;
  timestamp: Date;
  content: string;
  timeMarker?: number;
}

// Mock data for files
export const mockProjectFiles: ProjectFile[] = [
  {
    id: "1",
    projectId: "1",
    name: "Vocals - Take 3.wav",
    type: "audio",
    format: "WAV",
    size: "24.5 MB",
    uploadedBy: "user456",
    uploadedAt: new Date("2023-06-05"),
    version: 1,
    url: "https://example.com/files/vocals-take-3.wav"
  },
  {
    id: "2",
    projectId: "1",
    name: "Mix Draft v2.wav",
    type: "audio",
    format: "WAV",
    size: "35.2 MB",
    uploadedBy: "user123",
    uploadedAt: new Date("2023-06-08"),
    version: 2,
    url: "https://example.com/files/mix-draft-v2.wav",
    comments: [
      {
        id: "c1",
        fileId: "2",
        userId: "user456",
        userName: "Jamie Collins",
        timestamp: new Date("2023-06-09T14:30:00"),
        content: "Could we bring up the vocals around 1:20?",
        timeMarker: 80
      }
    ]
  },
  {
    id: "3",
    projectId: "2",
    name: "Guitar Stems.zip",
    type: "audio",
    format: "ZIP",
    size: "102 MB",
    uploadedBy: "user123",
    uploadedAt: new Date("2023-05-28"),
    version: 1,
    url: "https://example.com/files/guitar-stems.zip"
  },
  {
    id: "4",
    projectId: "3",
    name: "Lyrics Draft.docx",
    type: "document",
    format: "DOCX",
    size: "152 KB",
    uploadedBy: "user789",
    uploadedAt: new Date("2023-06-03"),
    version: 3,
    url: "https://example.com/files/lyrics-draft.docx",
    comments: [
      {
        id: "c2",
        fileId: "4",
        userId: "user456",
        userName: "Jamie Collins",
        timestamp: new Date("2023-06-04T10:15:00"),
        content: "I love the second verse! The chorus needs some work though."
      }
    ]
  }
];
